const stripDiagnosisCode = (source: string): string =>
  source.replace(/\s*[-–]\s*[A-Za-z]?\d[\w.]*\s*$/i, "").trim();

export const getPrimarySource = (
  sourceText: Record<string, number> | undefined | null,
): string => {
  if (!sourceText) return "";
  const [first] = Object.keys(sourceText);
  return first ? stripDiagnosisCode(first) : "";
};

export const getSourceSuggestions = (
  sourceText: Record<string, number> | undefined | null,
  limit = 2,
): string[] => {
  if (!sourceText) return [];
  const suggestions: string[] = [];
  for (const source of Object.keys(sourceText)) {
    const cleaned = stripDiagnosisCode(source);
    if (cleaned && !suggestions.includes(cleaned)) suggestions.push(cleaned);
    if (suggestions.length >= limit) break;
  }
  return suggestions;
};
